module.exports = __webpack_public_path__ + "static/media/avatar_clownfish.9e5dc7c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_clownfish.png
// module id = 373
// module chunks = 0